export function axCoerceUint(x) {
    return x >>> 0;
}
